import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  fetchMakerCheckerListFail,
  fetchMakerCheckerListSuccess,
  FETCH_MAKER_CHECKER_LIST,
  FETCH_GENERAL_MAKER_CHECKER_LIST,
  fetchGeneralMakerCheckerListSuccess,
  fetchGeneralMakerCheckerListFail
} from '../../redux/actions/cm/makerChecker';
import {
  fetchGeneralMakerCheckerList,
  fetchMakerCheckerList
} from '../../services/cm/makerChecker';

function* fetchMakerCheckerListWorker({ filters, currentPage, pageSize }) {
  try {
    const { cases, total } = yield call(fetchMakerCheckerList, {
      filters,
      currentPage,
      pageSize
    });

    yield put(fetchMakerCheckerListSuccess({ cases, total }));
  } catch (error) {
    yield put(fetchMakerCheckerListFail());
  }
}

function* fetchGeneralMakerCheckerListWorker({
  filters,
  currentPage,
  pageSize
}) {
  try {
    const { response: items, itemCount: total } = yield call(
      fetchGeneralMakerCheckerList,
      {
        filters,
        currentPage,
        pageSize
      }
    );

    yield put(fetchGeneralMakerCheckerListSuccess({ items, total }));
  } catch (error) {
    yield put(fetchGeneralMakerCheckerListFail());
  }
}

export function* watchFetchMakerCheckerList() {
  yield takeEvery(
    FETCH_MAKER_CHECKER_LIST,
    function* ({ payload: { filters, currentPage, pageSize } }) {
      yield fork(fetchMakerCheckerListWorker, {
        filters,
        currentPage,
        pageSize
      });
    }
  );
}

export function* watchFetchGeneralMakerCheckerList() {
  yield takeEvery(
    FETCH_GENERAL_MAKER_CHECKER_LIST,
    function* ({ payload: { filters, currentPage, pageSize } }) {
      yield fork(fetchGeneralMakerCheckerListWorker, {
        filters,
        currentPage,
        pageSize
      });
    }
  );
}
